
export function arrangeQuestions(questions) {
  if (questions?.factors) {
    return questions.factors
      .flatMap((factor, f) =>
        factor.questions.map((q, idx) => ({
          question: q.q,
          factor: factor.id,
          q: idx,
          role: q.role,
          reverse: q.reverse,
          order: q.id,
          ques_id: q.id,
          fr: "fr" in q ? q.fr : null,
          title: q?.title ? q.title : questions?.question_titles ? factor.title : false,
          qualifier: q?.qualifier,
          scale: q?.scale,
        }))
      )
      .sort((a, b) => a.order - b.order);
  }
  return [];
}
